<template>
  <div class="v-timeline" :class="{ [extraClass]: !!extraClass }">
    <div class="v-timeline__status-track">
      <div v-for="item in items" :class="{ [item.status]: !!item.status }">
        <img :src="getImgSrc(item.status)" alt="dot" />
        <label>{{ item.title }}</label>
        <span v-if="item.status !== 'future'" class="extra">
          {{ item.time }}</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
import moment from "moment";

import dot from "@/assets/images/mapdot.svg";
import dotGray from "@/assets/images/mapdotgray.svg";

export default Vue.component("VTimeline", {
  data() {
    return {
      dot,
      dotGray
    };
  },
  props: {
    items: VueTypes.arrayOf(
      VueTypes.shape({
        title: VueTypes.string,
        status: VueTypes.oneOf(["current", "future", "complete"]).def("future"),
        time: VueTypes.string
      })
    ).isRequired,

    extraClass: VueTypes.string.def("")
  },

  methods: {
    getImgSrc(status) {
      return status === "future" ? this.dotGray : this.dot;
    }
  }
});
</script>

<style lang="scss" scoped>
$ns: "v-timeline";
$grey-timeline: #d1d1d1;

.#{$ns} {
  &__status-track {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-size: 1em;

    .complete {
      color: $primary-color;
    }

    .current {
      color: $primary-color;

      i {
        color: $grey-timeline;
      }
    }

    .future {
      color: $grey-timeline;

      label {
        color: $grey-timeline;
      }
    }

    > {
      * {
        text-align: center;
        line-height: 1.9;
        flex: 2;
        position: relative;
        display: flex;
        align-items: center;
        flex-direction: column;

        * {
          display: block;
        }

        label {
          max-width: 80px;
          line-height: 1.3;
          color: $secondary-text-color;
          font-size: 14px;
          margin-top: 10px;
          white-space: pre-wrap;
        }

        i.fa {
          font-size: 1.3em;
        }

        &:not(:first-child)::before {
          display: block;
          content: "";
          position: absolute;
          left: -50%;
          right: 50%;
          top: 0.6em;
          border-top: 0.15em dashed;
          margin: 0 0.6em;
        }

        img {
          width: 20px;
          height: 20px;
        }

        &:nth-child(2)::before {
          margin-left: 0.6em;
        }
      }
    }

    .extra {
      width: 70px;
      text-align: center;
      font-size: 11px;
      color: #747474;
      line-height: 1.3;
      font-family: "Lato-Medium", Arial, sans-serif;
      white-space: normal;
    }
  }
}
</style>
